import { useLocation } from 'react-router-dom';
import { IoMdMenu } from 'react-icons/io';
import { ElementType, useState } from 'react';
import classNames from 'classnames';
import logo from '../../../assets/logo.png';
import Button, { ButtonProps } from '../../../components/Button';
import Link, { LinkProps } from '../../../components/Link';
import Typography from '../../../components/Typography';
import styles from './Navigation.module.scss';
import Section from '../../../components/Section';
import IconButton from '../../../components/IconButton';

export interface NavigationProps<T extends ElementType> {
  links?: Omit<LinkProps<'navlink'>, 'type'>[];
  actions?: ButtonProps<T>[];
}

function Navigation<T extends ElementType>({
  links,
  actions,
}: NavigationProps<T>) {
  const location = useLocation();
  const currentLocation = `${location.pathname}${location.hash || '#'}`;
  const [show, setShow] = useState(false);

  return (
    <Section className={styles.nav} as="nav">
      <div className={styles.frame}>
        <Link type="link" to="/" className={styles.logo}>
          <img src={logo} alt="Inform logo" className={styles.img} />
        </Link>
        <IconButton
          onClick={() => setShow(!show)}
          className={styles.menu}
          icon={IoMdMenu}
        />
        <div className={classNames(show && styles.show, styles.content)}>
          {links && (
            <ul className={styles.links}>
              {links.map((linkProps, key) => (
                <Typography
                  className={styles.item}
                  as="li"
                  textType="p1"
                  key={key}
                >
                  <Link
                    {...linkProps}
                    className={classNames(
                      linkProps.to === currentLocation &&
                        styles['link--active'],
                      styles.link,
                    )}
                    type="navlink"
                  />
                </Typography>
              ))}
            </ul>
          )}
          {actions && (
            <div className={styles.actions}>
              {actions.map((action, key) => (
                <Button {...action} key={key} />
              ))}
            </div>
          )}
        </div>
      </div>
    </Section>
  );
}

export default Navigation;
